<template>
  <div class="content-body" id="activeFlights">      
       
    <div class="row match-height">
		  <div class="col-md-12"> 
              <div class="card" v-if="noData">
                   <div class="card-header">
                        <h3 class="card-title"><i class="icon-price-tags"></i> {{$t('titles.noData')}}</h3>                        
                    </div>
                </div>       
                <div class="card" v-if="!noData">
                    <div class="card-header">
                        <h3 class="card-title"><i class="icon-price-tags"></i> {{$t('titles.completedFlights')}}</h3>                        
                    </div>
                    <div class="card-body">                        
                        <div class="container-fluid">
                            <div class="row" style="padding-left:20px">
                                <div class="col-md-12 mb-2">
                                    <fieldset class="position-relative">
                                        <input type="text" class="form-control form-control input" placeholder="" v-model="filterStr" >
                                        <div class="form-control-position" style="top:5px; right:10px;">
                                            <i class="icon-search4 font-medium-4"></i>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </div>                        

                        <div class="card-block pt-0" >                         
                       <!-- ______________________________________main-tables    -->
                        <div class="main-tables mobileTbl table-responsive" v-if="viewTable">
                                <table class="table table-hover mb-0 loading" cellspacing="0" >
                                    <thead>
                                        <tr>     
                                            <th style="vertical-align: middle;">{{ $t('tender.table.numberFlight') }}</th>   
                                            <th style="vertical-align: middle;">{{ $t('table.order') }}</th>                                                        
                                            <!-- <th style="vertical-align: middle;">{{ $t('tender.table.date') }}</th> -->
                                            <th style="vertical-align: middle;">{{ $t('tender.table.driver') }}</th>                                                                                                         
                                            <th style="vertical-align: middle;">{{ $t('tender.table.car') }}</th>
                                            <th style="vertical-align: middle;">{{ $t('tender.table.adress') }}</th>
                                            <th style="vertical-align: middle;">{{ $t('table.delivery-date') }}</th>
                                            <!-- <th style="vertical-align: middle;">{{ $t('tender.table.dateReceivedLocation') }}</th> 
                                            <th style="vertical-align: middle;">{{ $t('table.place') }}</th>  -->
                                            <!-- <th style="vertical-align: middle;"></th>  -->
                                                              
                                        </tr>
                                    </thead>                                                       
                                    <tbody>                              
                                        <tr class="marginTR" v-for="(item,index) in paginatedData" :key="index"> 
                                            <td :data-title="$t('tender.table.numberFlight')"> {{item.number}} </td>
                                            <td :data-title="$t('table.order')"> {{item.listOrder}} </td>
                                            <!-- <td :data-title="$t('tender.table.date')"> {{item.date}}</td>                                             -->
                                            <td  :data-title="$t('tender.table.driver')">{{item.driver}}</td>
                                            <td  :data-title="$t('tender.table.car')">{{item.car}}</td>
                                            <td  :data-title="$t('tender.table.adress')">{{item.address}}</td>
                                            <td  :data-title="$t('table.delivery-date')">{{item.dateUnloading}}</td>
                                            <!-- <td  :data-title="$t('tender.table.dateReceivedLocation')">{{item.dateReceivedLocation}}</td>
                                            <td  :data-title="$t('table.place')">{{item.place}}</td> -->
                                            
                                            <!-- <td  :data-title="$t('table.place')"><span style="cursor:pointer" @click="showgmap(item.guidDoc)"><i class=" font-medium-4 icon-location2"></i></span></td> -->
                                            
                                        </tr>   
                                    </tbody>
                                </table>



                        </div>
                        <!-- ____________________and main tables -->
                       
                        <div class="" style="text-align: center;">
                            <ul class="pagination">
                                <li class="page-item" v-if="pageNumber > 0">
                                    <a class="page-link" @click="pageNumber--" ><i class="icon-arrow-left2"></i></a>
                                </li>
                                
                                <li class="page-item" v-bind:class="{active : (pageNumber == (page - 1))}" v-for="(page, index) in pages" :key="index" >
                                    <a v-if="page != '...'" class="page-link" @click="pageNumber = (page - 1)">{{page}}</a>
                                    <a v-else class="page-link" :id="index">{{page}}</a>
                                </li>
                                
                                <li class="page-item" v-if="pageNumber < pageCount - 1">
                                    <a class="page-link"  @click="pageNumber++"><i class="icon-arrow-right2"></i></a>
                                </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  



         <!-- Modal -->
            <vue-modal :on-close="closeModalMap"
            name="map-modal">
            <h3 slot="header" style="text-align:center">{{ $t('label.transport-location')}}</h3>
            <div class="row row-map">
                <GmapMap  
                        :center="position"                     
                        :zoom="4"
                        map-type-id="terrain"
                        style="height: 600px">
                    <GmapMarker                                                      
                            :position= "position"
                            :clickable="true"
                            :draggable="true"
                    />
                </GmapMap>
            </div>
            <br/>
            <div class="row">
                <div class="col-md-12 mb-3">
                </div>
            </div>
        </vue-modal>
    <!-- And Modal -->  
  </div> 
</template>
<script>
//import json from "../structure.json";
  export default {
    name: "active_flights",
    components: {           
        },
    data(){
      return{
          viewTable:true,
            listOfTender:{},
            list:[],
            position:{
                lat:0,
                lng:0
            },
            noData:null,
            center:{ lat: 50.761871, lng: 25.3562243 },
            selecteadTender: {},            
            chVarEq: null,
            showVars: false,               
            modalTitle:"Підтвердити участь",
            filterStr: "",
            pageNumber: 0,
            direction: 'asc',
            classSort: 'icon-sort-amount-asc',
            boolDir: true,
            sortKey: '',
            size:10,
            paggSize:5,
            tender: {
          typeOfTansportationVal: null,
          statuses:[
            {name: 'statuses.all', value: '', id: 0, checked: true},
            {name: 'statuses.new',value: 'new', id: 1, checked: false},
            // {name: "statuses.done", value: "done", id: 2, checked: false},            
            // {name: "statuses.cancel", value: "cancel", id: 3, checked: false},
            // {name: "statuses.process", value: "process", id: 4, checked: false},
            {name: "statuses.accepted", value: "accepted", id: 5, checked: false},
          ],
            choosen:[
                {name: 'statuses.all', value: '', id: 0, checked: true},
            ]   
        },
      }
    },
    methods: {  
        showgmap(id){
             let dataRequest = {};
                dataRequest.guidDoc = id;               
                this.makeQuery("/portal/getPositionFlight ", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res.data){ 
                        this.position.lat = res.data.Latitude 
                        this.position.lng = res.data.Longitude 
                        this.list = [res.data];
                        
                        console.log(res) 
                        
                         this.$modals.show("map-modal")            
                    }
                });

        }, 
         closeModalMap: function () {
          this.list = [];
         this.center = { lat: 50.761871, lng: 25.3562243 };
          this.$modals.hide("map-modal");
      },
       showModalMap: function (order) {
          this.getPositionCar(order)
          this.$modals.show("map-modal")
      },   
        getFlightClient(){                            
                let dataRequest = {};
                dataRequest.guidClient = this.$store.state.guidClient; 
                dataRequest.active = "0";              
                this.makeQuery("/portal/getFlightClient", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res.data && res.data.length > 0){ 
                        this.listOfTender = res.data                
                    }
                    else {
                        this.noData = true
                        console.log(`lenght = ${res.data.length}`)
                        
                        }
                });           
        },

        filtrClick(item){        
                let arr = this.tender;                
                arr.choosen = [];
                let notall = false;
                item.checked = !item.checked;
                let bool = item.checked;

                let itemAll =  arr.statuses[0];

                if(item == itemAll){
                    for (let i = 0; i <  arr.statuses.length; i++){
                        if( arr.statuses[i] != item){ arr.statuses[i].checked = false;}
                    }
                } else {
                    if(itemAll.checked == true){
                        item.checked = true;
                        for (let i = 0; i <  arr.statuses.length; i++) {
                            if( arr.statuses[i] != item){
                                 arr.statuses[i].checked = false;
                            }
                            
                        }
                    } else {
                        for (let i = 0; i <  arr.statuses.length; i++) {
                            if(( arr.statuses[i].checked == false) && ( arr.statuses[i] != itemAll)){
                                notall = true;
                            }
                            
                        }

                        console.log(notall)
                        if(notall == true){
                            itemAll.checked = false;
                        } else {
                            itemAll.checked = true;
 
                            for (let i = 0; i <  arr.statuses.length; i++) {
                                if( arr.statuses[i] != itemAll){
                                     arr.statuses[i].checked = false;
                                }
                            }
                        }
                    }
                }

                //нажаті
                for (let i = 0; i <  arr.statuses.length; i++) {
                    if( arr.statuses[i].checked == true){
                        arr.choosen.push( arr.statuses[i]);
                    }
                }
                if(arr.choosen.length < 1){
                    arr.statuses[0].checked = true;
                    arr.choosen.push(arr.statuses[0]);
                }

                
            }            
     
    },
    computed:{
      listFiltered: function(){
                let find = this.filterStr.toLowerCase();
                // let filterBystatus = this.tender.statuses;
                let found1 = true;
                let found2 = false;
                this.pageNumber = 0;
               if (!_.isEmpty(this.listOfTender)){
                   return this.listOfTender.filter(item => {
                    found1 = false;
                    found2 = false;
                    if( (find == '') || ((item.number != null) && (item.number.toLowerCase().indexOf(find) > -1))
                    || ((item.listOrder != null) && (item.listOrder.toLowerCase().indexOf(find) > -1))
                    || ((item.driver != null) && (item.driver.toLowerCase().indexOf(find) > -1))
                    || ((item.car != null) && (item.car.toLowerCase().indexOf(find) > -1))
                    || ((item.address != null) && (item.address.toLowerCase().indexOf(find) > -1))
                    || ((item.mobile != null) && (item.mobile.toLowerCase().indexOf(find) > -1)) ){
                        found1 = true;
                    }

                    for (let i = 0; i < this.tender.choosen.length; i++){
                        if( (this.tender.choosen[i].id == 0) || ((item.status != null) && (item.status == this.tender.choosen[i].id))){
                            found2 = true; 
                            break;
                        }
                    }
                    if(found1 && found2){
                        return item;
                    }
                })
                }
                else return {}
              
                
            },            
            pageCount(){
                let l = this.listFiltered.length, s = this.size;
                return Math.ceil(l/s);
            },
            pages: function(){
                let arr = [];
                for (let i = 0; i < this.pageCount; i++) { 
                    arr[i] = i + 1;
                }
                let divider = Math.trunc(this.paggSize/2);
                let start = this.pageNumber - divider;
                let end = this.pageNumber + divider + 1;
                if (start < 0) {
                    start = 0;
                }
                let final_arr = arr.slice(start,end);
                if ((start + 1) > arr[0]){
                    final_arr.unshift('...');
                }
                if(end < arr[arr.length - 1]){
                    final_arr.push('...');
                }
                return final_arr;
            },
            paginatedData(){
                if (this.sortedData.length > 0){
                    const start = this.pageNumber * this.size,
                        end = start + this.size;
                    return this.sortedData.slice(start, end);
                }
            },
            sortedData: function () {
                return _.orderBy(this.listFiltered, this.sortKey, this.direction);
            },
    },
    created() {
        
    },
    mounted(){  
        this.getFlightClient();
    }
  }
</script>

<style scoped>
#activeFlights {
    font-family: Inter,sans-serif!important;
    font-size: 0.8rem;
}
.card .card-title {
    text-transform: none
}


</style> 


// WEBPACK FOOTER //
// src/pages/CompletedFlights.vue